import { mainLayoutLocators } from '@locators/main-layout';
import { Form } from '@servicetitan/design-system';

export const NumberRadioButtonCell: React.FC<{
  checked: boolean;
  disabled?: boolean;
  id: string;
  onClick: () => void;
}> = ({ checked, id, disabled, onClick }) => {
  return (
    <td>
      <Form.Radio
        id={`${mainLayoutLocators.outboundCallerIdModal.numberRowRadioBtn}-${id}`}
        checked={checked}
        label=''
        onClick={onClick}
        disabled={disabled}
      />
    </td>
  );
};
